var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0429 12C16.0429 14.2091 14.2521 16 12.0429 16C9.83381 16 8.04294 14.2091 8.04294 12C8.04294 9.79086 9.83381 8 12.0429 8C14.2521 8 16.0429 9.79086 16.0429 12ZM14.5429 12C14.5429 13.3807 13.4237 14.5 12.0429 14.5C10.6622 14.5 9.54294 13.3807 9.54294 12C9.54294 10.6193 10.6622 9.5 12.0429 9.5C13.4237 9.5 14.5429 10.6193 14.5429 12Z",
    className: "Icon-fill-color"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4901 10.6497C23.1569 11.4401 23.1569 12.5599 22.4901 13.3503C20.6684 15.5098 16.6756 19.5 12.0429 19.5C7.41031 19.5 3.41746 15.5098 1.59577 13.3503C0.929015 12.5599 0.929015 11.4401 1.59577 10.6497C3.41746 8.49021 7.41031 4.5 12.0429 4.5C16.6756 4.5 20.6684 8.49021 22.4901 10.6497ZM21.3436 12.3831C20.4787 13.4084 19.1193 14.8413 17.4586 16.0074C15.7873 17.181 13.9319 18 12.0429 18C10.154 18 8.29864 17.181 6.62726 16.0074C4.96661 14.8413 3.60722 13.4084 2.7423 12.3831C2.54684 12.1514 2.54684 11.8486 2.7423 11.6169C3.60722 10.5916 4.96661 9.15874 6.62726 7.99262C8.29863 6.81896 10.154 6 12.0429 6C13.9319 6 15.7873 6.81896 17.4586 7.99261C19.1193 9.15874 20.4787 10.5916 21.3436 11.6169C21.539 11.8486 21.539 12.1514 21.3436 12.3831Z",
    className: "Icon-fill-color"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatch);
export default __webpack_public_path__ + "static/media/Watch.3ade4f1b5670633363872547eff4a7ef.svg";
export { ForwardRef as ReactComponent };